import React from 'react';

import { Redirect, useLocation } from 'react-router-dom';

import Condition from 'components/Condition';
import ProgressBar from 'components/ProgressBar/ProgressBar';
import paths from 'constants/paths';
import PERMISSIONS from 'constants/user/permissions';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import InquirySettingsProvider from 'modules/Inquiry/InquirySettingsProvider';
import InquirySpecificTypeForm from 'pages/inquiryFlow/InquirySpecificTypeForm';
import { useSelectedInquiryTypeSpecificValue } from 'shared/chooseSelectedInquiryTypeSpecificComponent';
import { useShowProgressBar } from 'utils/hooks/useShowProgressBar';
import { hasPermission as hasPermissionCreator, isLoggedInUser } from 'utils/user/conditionals';

import CreateInquiryNotAllowed from './CreateInquiryNotAllowed';

const useNewInquiryGate = () => {
  /* ATTENTION: Inquiry types that should be blocked from accessing /anfragen/neue have to
  have a root path set for new inquiries in src/store/config/reducer.js => startUrlForInquiryType */
  const { pathname } = useLocation();
  const hasPermission = hasPermissionCreator();

  const inquiryTypeSpecificCondition = useSelectedInquiryTypeSpecificValue({
    [InquiryType.default]: true,
    [InquiryType.cbBank]: !isLoggedInUser(),
  });
  const canCreateInquiry =
    (hasPermission(PERMISSIONS.INQUIRY.CREATE) || pathname === paths.finalPage) &&
    inquiryTypeSpecificCondition;

  const InquiryListRedirect = <Redirect to={paths.customer.inquiryList} />;
  const SubstituteComponent = useSelectedInquiryTypeSpecificValue({
    [InquiryType.dzb]: InquiryListRedirect,
    [InquiryType.mmv]: InquiryListRedirect,
    [InquiryType.leaseplan]: InquiryListRedirect,
    [InquiryType.cbBank]: InquiryListRedirect,
    [InquiryType.default]: <CreateInquiryNotAllowed />,
  });

  return { canCreateInquiry, SubstituteComponent };
};

const InquiryCreate = () => {
  const { canCreateInquiry, SubstituteComponent } = useNewInquiryGate();
  const showProgressBar = useShowProgressBar();

  if (!canCreateInquiry) {
    return SubstituteComponent;
  }

  return (
    <main>
      <InquirySettingsProvider>
        <Condition condition={showProgressBar}>
          <ProgressBar />
        </Condition>
        <InquirySpecificTypeForm />
      </InquirySettingsProvider>
    </main>
  );
};

export default InquiryCreate;
